import { Outlet, useOutletContext } from 'react-router-dom'

import { TrainingMembershipFragment, TrainingsSession } from 'generated/resources/graphql'

const EmployeeSessionModalCertificates = () => {
  const { employeeId, employeeAccessId, trainingId, session, trainingMemberships } =
    useOutletContext<{
      employeeId: number
      employeeAccessId: number
      trainingId: number
      session: TrainingsSession
      trainingMemberships: TrainingMembershipFragment[]
    }>()

  const trainingMembership = trainingMemberships.find(
    (membership) =>
      membership.trainingId === Number(trainingId) && membership.accessId === employeeAccessId
  )
  return (
    <Outlet context={{ employeeId, employeeAccessId, trainingId, session, trainingMembership }} />
  )
}

export default EmployeeSessionModalCertificates
